export const kUnknownTileType = "Unknown";
